import { Pipe, PipeTransform } from "@angular/core";
import { DomSanitizer, SafeHtml } from "@angular/platform-browser";

/** Renders safe HTML sting as HTML  */
@Pipe({name: "safeHtml"})
export class SafeHtmlPipe implements PipeTransform {
    constructor(private sanitizer: DomSanitizer) {}

    /**
     * The Transform method that implements the Pipe
     * @param html - The HTML that we want to display.
     */
    public transform(html: string) {
        return this.sanitizer.bypassSecurityTrustHtml(html);
    }
}
